import React from 'react';
import '../../news-pages.css'
import Parse from 'html-react-parser'

import OwlCarousel from 'react-owl-carousel'
import 'owl.carousel/dist/assets/owl.carousel.css'
import 'owl.carousel/dist/assets/owl.theme.default.css'

import cover from './cover.jpg'
import pic1 from './pic1.jpg'
import pic2 from './pic2.jpg'
import pic3 from './pic3.jpg'
import pic4 from './pic4.jpg'
import pic5 from './pic5.jpg'
import pic6 from './pic6.jpg'
import pic7 from './pic7.jpg'
import pic8 from './pic8.jpg'
import pic9 from './pic9.jpg'
import pic10 from './pic10.jpg'
import pic11 from './pic11.jpg'




const Id2 = () => {

    const detail = 
        {
            id:28,
            imgSrc:cover,
            ini:'Training SATIT Primary School Students on Zoonoses (First Day)',
            href:'',
            element:'',
            topic:'On 25 May 2026, The LUCENT team and IJL PRESTO organized hands-on training for the students of the SATIT Primary school at the Demonstration School (SATIT) of Chiang Mai University with the supported of IRD COSAV One-HEALTH. Dr. Dorothée Missé (IRD Research Director, coordinator of IJL PRESTO) chaired the opening of the educational activities. The training was led by Assoc. Prof. Dr. Saengduen Moonsom from the Thailand One Health University Network (THOHUN) and Asst. Prof. Dr. Woottichai Khamduang, Participants were SATIT grade 3 primary students.<br> the aim of the first day was to provide the students with basic knowledge about the transmission of zoonotic disease through interactive and fun activities.',
            inform:``,
            link1:`https://lucent.ams.cmu.ac.th/view_activity.html?id=49`,
        }
    
        const handleLink1 = () =>{
            window.open(detail.link1, '_blank', 'noreferrer')
        }

    const imgs = [
        {
            imageSrc: cover,
            alt: 'cover',
            title: 'cover',
            thumbnailImageSrc: cover
        },
        {
            imageSrc: pic1,
            alt: 'pic1',
            title: 'pic1',
            thumbnailImageSrc: pic1
        },
        {
            imageSrc: pic2,
            alt: 'pic2',
            title: 'pic2',
            thumbnailImageSrc: pic2
        },
        {
            imageSrc: pic3,
            alt: 'pic3',
            title: 'pic3',
            thumbnailImageSrc: pic3
        },
        {
            imageSrc: pic4,
            alt: 'pic4',
            title: 'pic4',
            thumbnailImageSrc: pic4
        },
        {
            imageSrc: pic5,
            alt: 'pic5',
            title: 'pic5',
            thumbnailImageSrc: pic5
        },
        {
            imageSrc: pic6,
            alt: 'pic6',
            title: 'pic6',
            thumbnailImageSrc: pic6
        },
        {
            imageSrc: pic7,
            alt: 'pic7',
            title: 'pic7',
            thumbnailImageSrc: pic7
        },
        {
            imageSrc: pic8,
            alt: 'pic8',
            title: 'pic8',
            thumbnailImageSrc: pic8
        },
        {
            imageSrc: pic9,
            alt: 'pic9',
            title: 'pic9',
            thumbnailImageSrc: pic9
        },
        {
            imageSrc: pic10,
            alt: 'pic10',
            title: 'pic10',
            thumbnailImageSrc: pic10
        },
        {
            imageSrc: pic11,
            alt: 'pic11',
            title: 'pic11',
            thumbnailImageSrc: pic11
        },
    ]

    return (
        <div className='elements containers'>
            <div className="img-slicer">
                <OwlCarousel
                    className='owl-theme'
                    loop={true}
                    margin={10}
                    lazyLoad={true}
                    nav
                    items={1}
                    autoplay={true}
                    autoplayTimeout={3000}
                    autoplayHoverPause={true}
                    smartSpeed={1000}
                >
                    {imgs.map((img,index)=>(
                        <div className="item" key={index}><img src={img.imageSrc} alt="item" /></div>
                    ))}
                </OwlCarousel>
            </div>
            <div className="text">
                <h1>{detail.ini}</h1>
                <h2>{Parse(detail.topic)}</h2>
                <p>{Parse(detail.inform)}</p>
                <div className="btn">
                    <h2>MORE INFORMATION</h2>
                    <button onClick={handleLink1}>{detail.link1}</button>
                </div>
            </div>
        </div>
    );
}

export default Id2;
